import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { intentTypes } from "@/constants/ab-test-intents";
import type { IntentType } from "@/types/ab-tests";

interface IntentShiftSelectorProps {
  intentFrom: IntentType;
  intentTo: IntentType;
  onIntentFromChange: (value: IntentType) => void;
  onIntentToChange: (value: IntentType) => void;
}

export function IntentShiftSelector({
  intentFrom,
  intentTo,
  onIntentFromChange,
  onIntentToChange,
}: IntentShiftSelectorProps) {
  const filteredIntentTypes = intentTypes.filter((i) => i !== intentFrom);

  return (
    <div className="space-y-2">
      <Label>Intent shift</Label>
      <div className="grid grid-cols-[1fr_auto_1fr] items-end gap-3">
        <div className="space-y-1.5">
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">From</p>
          <Select value={intentFrom} onValueChange={(v: IntentType) => onIntentFromChange(v)}>
            <SelectTrigger className="text-sm w-full">
              <SelectValue placeholder="Current intent..." />
            </SelectTrigger>
            <SelectContent>
              {intentTypes.map((i) => (
                <SelectItem key={i} value={i}>{i}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="pb-2 text-xs font-medium text-muted-foreground">→</div>
        <div className="space-y-1.5">
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">To</p>
          <Select value={intentTo} onValueChange={(v: IntentType) => onIntentToChange(v)}>
            <SelectTrigger className="text-sm w-full">
              <SelectValue placeholder="Target intent..." />
            </SelectTrigger>
            <SelectContent>
              {filteredIntentTypes.map((i) => (
                <SelectItem key={i} value={i}>{i}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
